module.exports = __webpack_public_path__ + "img/img_huasuhui.2fecfa8c.png";